import { EDIT_ADDRESS_ATTEMPT, EDIT_ADDRESS_SUCCESS, EDIT_ADDRESS_FAILED , RESET_EDIT_ADDRESS} from '../../actions/types'
const INITIAL_STATE = {
    loading: false,
    message: null ,
    success: false
}
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case EDIT_ADDRESS_ATTEMPT:
            return { ...state, loading: true , success: false}
        case EDIT_ADDRESS_SUCCESS:
            return { ...state, loading: false, message: action.message, success: action.success  }
        case EDIT_ADDRESS_FAILED:
             return { ...state, loading: false, message: action.message, success: action.success }
        case RESET_EDIT_ADDRESS:
             return { ...state, loading: false , success: false, message: null }
        default:
            return state;
    }
}